module.exports = __webpack_public_path__ + "img/jbt9161_1_1999.prt.0cb48482.jpg";